import script from "./EventsMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsMap.vue?vue&type=script&setup=true&lang=ts"

import "./EventsMap.vue?vue&type=style&index=0&id=148980c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148980c6"]])

export default __exports__